import { Box, Card, Stack, Button, useTheme, Typography } from '@mui/material';

import { useResponsive } from 'src/hooks/use-responsive';

import { BRAND_COLOR } from 'src/theme/core';

export const StartGenerateAssignment = ({
  setOpenDemoForm,
}: {
  setOpenDemoForm: (value: boolean) => void;
}) => {
  const lgDown = useResponsive('down', 'lg');
  const mdDown = useResponsive('down', 'md');
  const smDown = useResponsive('down', 'sm');
  const theme = useTheme();
  return (
    <Card
      sx={{
        my: 8,
        justifySelf: 'center',
        maxWidth: 1200,
        mx: lgDown ? 0 : 4,
        background: theme.palette.common.black,
        borderRadius: '16px',
        overflow: 'hidden',
        position: 'relative',
        zIndex: 0,
      }}
    >
      <Stack direction={mdDown ? 'column' : 'row'} justifyContent="space-between">
        <Stack alignItems="start" spacing={3} p={mdDown ? 2 : 6} flex={0.5} zIndex={2}>
          <Box component="img" src="/assets/sub-pages/logo-ant.svg" alt="logo" />
          <Stack>
            <Typography variant="h2" color="primary.contrastText">
              Bắt đầu ngay với CenterUp
            </Typography>
          </Stack>
          <Stack>
            <Typography fontSize={18} color="primary.contrastText">
              Không còn thủ công tạo từng câu hỏi - bài tập - đề thi
            </Typography>
            <Typography fontSize={18} color="primary.contrastText">
              Không còn phải sử dụng nhiều công cụ khác nhau
            </Typography>
          </Stack>
          <Typography fontSize={18} color="primary.contrastText">
            “Tạo mọi loại câu hỏi dễ dàng - với sự trợ giúp của AI”
          </Typography>
          <Stack direction="row" spacing={1} alignItems="center">
            <Button
              onClick={() => setOpenDemoForm(true)}
              size="large"
              sx={{
                background: BRAND_COLOR,
                color: 'white',
                '&:hover': {
                  background: BRAND_COLOR,
                  opacity: 0.9,
                },
                minWidth: 124,
              }}
            >
              Đăng ký Demo
            </Button>
            <Typography
              fontSize={smDown ? 12 : 18}
              color="primary.contrastText"
              sx={{ maxWidth: 353 }}
            >
              Để trải nghiệm cách tạo câu hỏi & đề thi kiểu mới với CenterUp
            </Typography>
          </Stack>
        </Stack>
        <Stack flex={0.5} position="relative" zIndex={1}>
          <Stack justifyContent="center" alignItems="center" height="100%" zIndex={1}>
            <Box component="img" alt="class-report" src="/assets/sub-pages/ai.png" />
          </Stack>
        </Stack>
      </Stack>
    </Card>
  );
};
